import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

import { PARTY_NAMESPACE } from '@/store/party'

export const KioskIntegrationState = {
  kiosk: {
    enabled: false,
  },
}

export const KioskIntegrationActions = {
  activateOnKiosk: async ({ commit }, partyId) => {
    return axiosRequest.patch('/kiosk/activate', { party_id: partyId }).
      then(({ data }) => {
        commit(`${PARTY_NAMESPACE}/pePatchParty`, { kiosk_status: data.party.kiosk_status }, { root: true })
      }).
      catch(handleError)
  },

  deactivateOnKiosk: async ({ commit }, partyId) => {
    return axiosRequest.patch('/kiosk/deactivate', { party_id: partyId }).
      then(({ data }) => {
        commit(`${PARTY_NAMESPACE}/pePatchParty`, { kiosk_status: data.party.kiosk_status }, { root: true })
      }).
      catch(handleError)
  },

  checkKioskEnabled: async ({ commit }) => {
    return axiosRequest.get('/admin/kiosk/enabled').
      then(({ data }) => commit('setKioskEnabled', data?.enabled || false)).
      catch(handleError)
  },
}

export const KioskIntegrationGetters = {
  isKioskEnabled: state => state.kiosk.enabled,
}

export const KioskIntegrationMutations = {
  setKioskEnabled: (state, data) => (state.kiosk.enabled = data),
}
